import { z } from 'zod';
import { MOTORES } from '@remoto/protocolo';

export * from './nivel';
export * from './coerencia';
export * from './frases';
export * from './avisos';
export * from './segredo';

export const OrigemPedidoSchema = z.enum(['SDK', 'GANCHO']);
export type OrigemPedido = z.infer<typeof OrigemPedidoSchema>;

/**
 * Espelho do `TipoPedidoSchema` do protocolo — os pacotes não se importam de
 * propósito, e o teste de contratos da API prende as duas listas.
 */
export const TipoPedidoSchema = z.enum([
  'FERRAMENTA',
  'PERGUNTA',
  'PLANO',
  'PROPOSTA',
  'ELICITACAO',
]);
export type TipoPedido = z.infer<typeof TipoPedidoSchema>;

export const EstadoPedidoSchema = z.enum([
  'PENDENTE',
  'PERMITIDO',
  'NEGADO',
  'RESOLVIDO_LOCALMENTE',
  'EXPIRADO',
  'CANCELADO',
]);
export type EstadoPedido = z.infer<typeof EstadoPedidoSchema>;

export const PedidoPermissaoSchema = z.object({
  id: z.string(),
  sessaoId: z.string(),
  sessaoNome: z.string().nullable(),
  maquinaNome: z.string(),
  /**
   * O motor da SESSÃO dona do pedido (F17). É ele que escolhe a frase do
   * cartão (`fraseDoPedido`) e o nível de pergunta (`nivelDePergunta`), que
   * são por motor: sem o campo, o cartão do Codex caía na frase do Claude.
   *
   * **Opcional e SEM `.default()`, e é decisão** — por isso `z.enum(MOTORES)`
   * e não o `MotorSchema`, que tem `.default('CLAUDE')`. Um padrão aqui
   * transformaria "a API não disse" (servidor antigo) em "é Claude", que é
   * exatamente o erro que o campo existe para acabar; ausente, o painel segue
   * com o motor da sessão que ele já tem na mão.
   */
  motor: z.enum(MOTORES).optional(),
  origem: OrigemPedidoSchema,
  tipo: TipoPedidoSchema.default('FERRAMENTA'),
  ferramenta: z.string(),
  entrada: z.record(z.string(), z.unknown()),
  sugestoes: z.array(z.record(z.string(), z.unknown())).nullable(),
  estado: EstadoPedidoSchema,
  titulo: z.string().nullable().optional(),
  rotuloCurto: z.string().nullable().optional(),
  descricao: z.string().nullable().optional(),
  motivo: z.string().nullable().optional(),
  agenteId: z.string().nullable().optional(),
  toolUseId: z.string().nullable().optional(),
  criadoEm: z.iso.datetime(),
  expiraEm: z.iso.datetime().nullable(),
});
export type PedidoPermissao = z.infer<typeof PedidoPermissaoSchema>;

/**
 * Pedidos vindos de sessão observada (VS Code/terminal) só valem enquanto o
 * hook HTTP está segurando a resposta. 300 s é o timeout do hook; respondemos
 * aos 290 s para nunca deixar o Claude cancelar a chamada por conta própria.
 */
export const TIMEOUT_HOOK_PERMISSAO_S = 300;
export const EXPIRA_PEDIDO_GANCHO_S = 290;
